import { createReduxStore } from '../../../shared/redux';
import { IApplicationContext } from '../../../shared/types/application';
import { IApplicationState } from '../../../shared/types/redux';

export function createApplicationState(context: IApplicationContext) {
  const initialState = context.config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, context, true);
}
